import React from "react";

const ReviewSkeleton = ({ stepsCount }) => (
  <div className="min-h-screen bg-background-primary flex flex-col px-10 py-8 animate-pulse">
    <div className="h-6 w-56 bg-background-secondary rounded mb-2" />
    <div className="h-3 w-80 bg-background-secondary rounded mb-8" />

    {/* Mobile: progress bar */}
    <div className="md:hidden flex flex-col gap-1 mb-6">
      <div className="h-2 w-full bg-background-secondary rounded-full" />
      <div className="h-3 w-24 bg-background-secondary rounded" />
    </div>

    {/* Desktop: step dots */}
    <div className="hidden md:flex items-center gap-1 mb-6 overflow-x-auto">
      {Array.from({ length: stepsCount }).map((_, i) => (
        <React.Fragment key={i}>
          <div className="w-7 h-7 rounded-full bg-background-secondary shrink-0" />
          {i < stepsCount - 1 && <div className="h-[2px] w-8 bg-background-secondary shrink-0" />}
        </React.Fragment>
      ))}
    </div>

    <div className="border border-background-secondary rounded-2xl p-6 space-y-5">
      <div className="h-5 w-40 bg-background-secondary rounded" />
      <div className="h-px bg-background-secondary" />
      <div className="grid grid-cols-2 gap-4">
        {[...Array(6)].map((_, i) => (
          <div key={i} className="space-y-2">
            <div className="h-3 w-20 bg-background-secondary rounded" />
            <div className="h-9 bg-background-secondary rounded-lg" />
          </div>
        ))}
      </div>
    </div>
  </div>
);

export default ReviewSkeleton;
